import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import sendRequest from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
// import PocChannelAdd from './PocChannelAdd';
// import PocChannelUpdate from './PocChannelUpdate';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import {
	formatDate,
	nNU,
	showConfirm,
	showToast
} from 'util/utils';
import { FaUserGroup } from 'react-icons/fa6';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

// export const accountRoleNameMap = {
//   0: string.ACCOUNT_ROLE_ADMIN,
//   1: string.ACCOUNT_ROLE_PARENT,
//   2: string.ACCOUNT_ROLE_CHILD,
// };

// export const accountStatusNameMap = {
//   true: string.ACTIVE,
//   false: string.INACTIVE,
// };

const Summary = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [currentUser.accountRole],
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
	const [summary, setSummary] = useState([]);

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      let data = await sendRequest({
        url: isAdmin ? Urls.admin.summary : Urls.admin.summary,
      });
      const { result } = data;
      if (!getAll) {
				let sum = [
					{
						id: 0,//4,
						// title: 'users',
						title: string.APP_SUM_TOTAL_USER,
						value: result?.users,
					},
					{
						id: 1,//0,
						// title: 'appIds',
						title: string.APP_SUM_TOTAL_POC_USER,
						value: result?.appIds,
					},
					{
						id: 2,//5,
						// title: 'validAppIds',
						title: string.APP_SUM_ACTIVE_POC_USER,
						value: result?.validAppIds,
					},
					{
						id: 3,//2,
						// title: 'invalidAppIds',
						title: string.APP_SUM_BAN_POC_USER,
						value: result?.invalidAppIds,
					},
					{
						id: 4,//1,
						// title: 'groupIds',
						title: string.APP_SUM_TOTAL_POC_CHANNEL,
						value: result?.groupIds,
					},
					{
						id: 5,//6,
						// title: 'validGroupIds',
						title: string.APP_SUM_ACTIVE_POC_CHANNEL,
						value: result?.validGroupIds,
					},
					{
						id: 6,//3,
						// title: 'invalidGroupIds',
						title: string.APP_SUM_BAN_POC_CHANNEL,
						value: result?.invalidGroupIds,
					},
				];
				setSummary(sum);
				setTotal(7);
				console.log(result);
      }
      return result;
    },
    [currentUser],
  );
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
				key: raw.id,
        data: [
					raw.title,
					raw.value,
				],
        raw,
      })),
    [],
  );

  //-------------------------------RETURN------------------------------------------------------------
	return (
		<>
      <Page
        title={string.APP_SUMMARY_PAGE_TITLE}
        body={
          <>
            <Table
              className="nowrap"
              // mainActions={mainActions}
              // page={page}
              // pageSize={pageSize}
              // total={total}
              // onPageChanged={setPage}
              // onPageSizeChanged={setPageSize}
              headers={[
                string.APP_SUMMARY_TITLE,
                string.APP_SUMMARY_VALUE,
							]}
              data={dataTable(summary)}
              getCSVData={!isMonitorOnly && (async () => {
                // return dataTable(await doSearch(1, total, true));
								return dataTable(summary);
              })}
              csvFileName="Summary"
              isPaging={false}
							// actions={actions}
            />
          </>
        }
      />
		</>
	);
};

export default Summary;
